import { EditItemCodesComponent } from '../../../../admin/items/edit/item-codes.component';
import { RelatedProductsComponent } from '../../../../admin/items/edit/related-products.component';
import { EditReorderConfigComponent } from '../../../../admin/items/edit/reorder-config.component';
import { WarehouseStockLevelsComponent } from '../../../../admin/warehouse/edit/warehouse-stock-levels/warehouse-stock-levels.component';
import { WorkOrderItemsComponent } from '../../view/jobs/work-order-items/work-order-items.component';
import {
  AssetTypeFaultCodesInputComponent,
  AssetTypeInspectionChecklistInputComponent,
  AssetTypeVariantsInputComponent,
  AssetTypeReportFieldsComponent
} from '../../../../module/asset-types';
import { ContractRecurringJobsComponent } from '../../../../module/contracts/contract-recurring-jobs/contract-recurring-jobs.component';
import { ContractRecurringInvoicesComponent } from '../../../../module/contracts/contract-recurring-invoices/contract-recurring-invoices.component';
import { ContractItemsComponent } from '../../../../module/contracts/contract-items/contract-items.component';
import {
  AssetActualFaultInputComponent,
  AssetVariantInputComponent,
} from '../../../../module/assets';
import { UserSkillsComponent } from '../../../../admin/users/components/input/user-skills/user-skills.component';

/**
 * Contains the appropriate component instance for each custom selector that represents the custom field.
 * Each component should be registered in client/src/app/shared/modules/edit.module.ts
 *
 * You should register the component in the following keys
 * - entryComponents - this is used to dynamically resolve components using the ComponentResolverFactory class
 * - declarations - the component should be part of the edit module
 */
export const CUSTOM_SELECTORS = {
  item_codes: EditItemCodesComponent,
  reorder_config: EditReorderConfigComponent,
  related_products: RelatedProductsComponent,
  warehouse_stock_levels: WarehouseStockLevelsComponent,
  work_order_items: WorkOrderItemsComponent,
  asset_type_variants: AssetTypeVariantsInputComponent,
  asset_type_reports: AssetTypeReportFieldsComponent,
  asset_type_fault_codes: AssetTypeFaultCodesInputComponent,
  asset_type_checklists: AssetTypeInspectionChecklistInputComponent,
  asset_actual_faults: AssetActualFaultInputComponent,
  contract_recurring_jobs: ContractRecurringJobsComponent,
  contract_recurring_invoices: ContractRecurringInvoicesComponent,
  contract_items: ContractItemsComponent,
  asset_variant: AssetVariantInputComponent,
  user_skills: UserSkillsComponent,
};
